import Swiper from "swiper";
import { Pagination, Navigation, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

var sliders = document.querySelectorAll(".product-carousel .swiper");
sliders.forEach((el) => {
	const swiper = new Swiper(`#${el.id}`, {
		modules: [Navigation, A11y],
		slidesPerView: "auto",
		spaceBetween: 10,
		centeredSlides: true,
		navigation: {
			nextEl: `#${el.id}-next`,
			prevEl: `#${el.id}-prev`,
		},
		breakpoints: {
			1025: {
				slidesPerView: 4,
				spaceBetween: 20,
				centeredSlides: false,
			},
		},
	});
});

var sliders = document.querySelectorAll(".features-overview .swiper");
sliders.forEach((el) => {
	const swiper = new Swiper(`#${el.id}`, {
		modules: [Navigation, A11y],
		slidesPerView: "auto",
		spaceBetween: 10,
		centeredSlides: true,
		navigation: {
			nextEl: `#${el.id}-next`,
			prevEl: `#${el.id}-prev`,
		},
	});
});

$(document).ready(function () {
	var srollaEnabled = false;
	if ($(window).width() >= LS.desktopBreakpoint) {
		$(".animate").scrolla({
			once: true,
		});
		srollaEnabled = true;
	}
	// images will stay missing if you start small and resize large
	$(window).resize(function () {
		if ($(window).width() >= LS.desktopBreakpoint && !srollaEnabled) {
			$(".animate").scrolla({
				once: true,
			});
			srollaEnabled = true;
		}
	});

	/*
  Discover Pearl: images need to swap positions in the DOM between tablet and desktop
    */
	var pearlAnywhereLayout = function () {
		if ($(window).width() < LS.desktopBreakpoint) {
			if (!$("#pearl-anywhere-col-1 #pearl-anywhere-4").length) {
				$("#pearl-anywhere-4")
					.detach()
					.appendTo("#pearl-anywhere-col-1");
				$("#pearl-anywhere-5")
					.detach()
					.prependTo("#pearl-anywhere-col-2");
			}
		} else if (!$("#pearl-anywhere-col-2 #pearl-anywhere-4").length) {
			$("#pearl-anywhere-4").detach().prependTo("#pearl-anywhere-col-2");
			$("#pearl-anywhere-5").detach().appendTo("#pearl-anywhere-col-1");
		}
	};
	if ($("#pearl-anywhere-col-1").length) {
		pearlAnywhereLayout();
		$(window).resize(function () {
			pearlAnywhereLayout();
		});
	}

	$("#zodiac-select").on("change", function (e) {
		e.preventDefault();
		$("#zodiac-signs .zodiac-details").hide();
		$("#zodiac-signs > div").hide();
		$(".zodiac-" + $(this).val()).fadeIn();
		$(".y-" + $(this).val()).fadeIn();
	});

	/*
  Misc Sliders
  */
	$("#waverley2-comparison-slider").slick({
		centerMode: true,
		dots: true,
		initialSlide: 1,
		variableWidth: true,
		mobileFirst: true,
		infinite: false,
		responsive: [
			{
				breakpoint: LS.tabletBreakpoint,
				settings: {
					dots: false,
				},
			},
		],
	});

	$("#neutrals-sand-slider .slides, #neutrals-rose-slider .slides").slick({
		centerMode: true,
		initialSlide: 1,
		variableWidth: true,
		mobileFirst: true,
		infinite: false,
	});

	$("#leather-wallet-slider").slick({
		dots: true,
		arrows: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: LS.tabletBreakpoint,
				settings: "unslick",
			},
		],
	});

	$(".compare-slider .items").slick({
		arrows: true,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$("#heroes-grid .item").each(function () {
		var $el = $(this);
		// 'delay' attribute on each item sets the order it will transition
		// order: 2-4-6-8-3-1-5-7-9
		window.setTimeout(function () {
			// show the second image after the delay is over to start the cycle
			$el.addClass("show-2");
			// allow enough time for delays to be complete, then cycle though visibility indefinitely
			window.setInterval(function () {
				if ($el.hasClass("show-5")) {
					$el.removeClass("show-2 show-3 show-4 show-5"); // reset to 1
				} else if ($el.hasClass("show-4")) {
					$el.addClass("show-5");
				} else if ($el.hasClass("show-3")) {
					$el.addClass("show-4");
				} else if ($el.hasClass("show-2")) {
					$el.addClass("show-3");
				} else {
					$el.addClass("show-2");
				}
			}, 9000);
		}, $el.data("delay") * 1000);
	});
	$("#heroes-quotes .quote-slider").slick({
		dots: false,
		arrows: true,
		fade: true,
		infinite: false,
		prevArrow: ".controls .slick-prev",
		nextArrow: ".controls .slick-next",
	});

	$(".continuous-carousel").slick({
		autoplay: true,
		autoplaySpeed: 0,
		speed: 10000,
		arrows: false,
		draggable: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		swipe: false,
		cssEase: "linear",
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
	});

	$(".expanding-panels-xs .toggle").on("click", function (e) {
		e.preventDefault();
		$(this).closest(".panel").toggleClass("active");
	});
});
